// SEO landing content for event-type pages (/evenements/:type)
export const EVENT_TYPES = ['mariage', 'festival', 'entreprise', 'club', 'concert', 'sport'];

export const EVENT_CONTENT = {
  mariage: {
    image: 'https://images.unsplash.com/photo-1708569177086-2710ef4b1620?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    fr: {
      name: 'Mariage',
      metaTitle: 'Bracelets LED pour Mariage | Party LED — Piste de danse inoubliable',
      metaDescription: 'Bracelets LED synchronisés pour mariage : ouverture de bal illuminée, photos magiques, marquage offert. Kits de 50 à 1000 invités. Livraison France & Dubai.',
      h1: 'Bracelets LED pour Mariage',
      subtitle: 'Transformez votre ouverture de bal en moment inoubliable',
      intro: 'Le moment où toute la salle s\'illumine en même temps, c\'est celui dont vos invités parleront pendant des années. Nos bracelets LED se synchronisent sur la musique de votre DJ et transforment votre piste de danse en spectacle. Chaque kit inclut le marquage de vos prénoms en 1 couleur, offert.',
      benefits: [
        'Ouverture de bal spectaculaire : tous les bracelets s\'allument à la seconde exacte de votre première danse.',
        'Des photos et vidéos incomparables : la lumière portée par vos invités éclaire chaque cliché.',
        'Vos prénoms et votre date gravés sur chaque bracelet — souvenir que vos invités gardent.',
        'Un lien NFC vers votre album photo, votre playlist ou votre livre d\'or numérique.',
      ],
      faq: [
        { q: 'Combien de bracelets pour mon mariage ?', a: 'Comptez un bracelet par invité présent sur la piste. Nos kits vont de 50 à 1000 personnes, avec un tarif dégressif.' },
        { q: 'Mon DJ peut-il piloter les bracelets ?', a: 'Oui. Chaque kit inclut un contrôleur au choix : mini contrôleur, contrôleur par application mobile ou console professionnelle pour ordinateur.' },
        { q: 'Peut-on personnaliser les bracelets ?', a: 'Le marquage en 1 couleur (prénoms, date, initiales) est offert avec chaque kit, ainsi que l\'insertion d\'un lien NFC.' },
      ],
      cta: 'Voir les kits mariage',
    },
    en: {
      name: 'Wedding',
      metaTitle: 'LED Wristbands for Weddings | Party LED — Unforgettable dance floor',
      metaDescription: 'Synchronised LED wristbands for weddings: glowing first dance, magical photos, free branding. Kits from 50 to 1000 guests. Delivery France & Dubai.',
      h1: 'LED Wristbands for Weddings',
      subtitle: 'Turn your first dance into an unforgettable moment',
      intro: 'The moment the whole room lights up at once is the one your guests will talk about for years. Our LED wristbands sync to your DJ\'s music and turn your dance floor into a show. Every kit includes your names printed in one colour, free of charge.',
      benefits: [
        'Spectacular first dance: every wristband lights up on the exact beat.',
        'Unmatched photos and videos: light carried by your guests brightens every shot.',
        'Your names and date printed on each wristband — a keepsake guests take home.',
        'An NFC link to your photo album, playlist or digital guest book.',
      ],
      faq: [
        { q: 'How many wristbands do I need?', a: 'Count one wristband per guest on the dance floor. Our kits cover 50 to 1000 people with volume pricing.' },
        { q: 'Can my DJ control the wristbands?', a: 'Yes. Every kit includes one controller of your choice: mini controller, mobile app controller or professional desktop console.' },
        { q: 'Can wristbands be personalised?', a: 'One-colour branding (names, date, initials) is included free with every kit, along with an NFC link.' },
      ],
      cta: 'See wedding kits',
    },
    ar: {
      name: 'حفل زفاف',
      metaTitle: 'أسورة LED لحفلات الزفاف | Party LED',
      metaDescription: 'أسورة LED متزامنة لحفلات الزفاف: رقصة أولى مضاءة، صور ساحرة، طباعة مجانية. أطقم من 50 إلى 1000 ضيف. توصيل إلى فرنسا ودبي.',
      h1: 'أسورة LED لحفلات الزفاف',
      subtitle: 'حوّل رقصتك الأولى إلى لحظة لا تُنسى',
      intro: 'اللحظة التي تضيء فيها القاعة بالكامل معًا هي التي سيتحدث عنها ضيوفك لسنوات. تتزامن أسورتنا مع موسيقى منسق الأغاني وتحوّل حلبة الرقص إلى عرض. كل طقم يشمل طباعة أسمائكم بلون واحد مجانًا.',
      benefits: [
        'رقصة أولى مذهلة: تضيء جميع الأسورة في اللحظة نفسها.',
        'صور وفيديوهات لا مثيل لها: الضوء الذي يحمله ضيوفك ينير كل صورة.',
        'أسماؤكم وتاريخكم مطبوعان على كل سوار — تذكار يحتفظ به الضيوف.',
        'رابط NFC إلى ألبوم صوركم أو قائمة الأغاني أو سجل الضيوف الرقمي.',
      ],
      faq: [
        { q: 'كم سوارًا أحتاج لحفل زفافي؟', a: 'احسب سوارًا لكل ضيف على حلبة الرقص. أطقمنا تغطي من 50 إلى 1000 شخص بأسعار متدرجة.' },
        { q: 'هل يمكن لمنسق الأغاني التحكم بالأسورة؟', a: 'نعم. كل طقم يشمل وحدة تحكم واحدة من اختيارك: صغيرة، عبر تطبيق الهاتف، أو وحدة احترافية للكمبيوتر.' },
        { q: 'هل يمكن تخصيص الأسورة؟', a: 'الطباعة بلون واحد (الأسماء، التاريخ، الأحرف الأولى) مجانية مع كل طقم، بالإضافة إلى رابط NFC.' },
      ],
      cta: 'اطلع على أطقم الزفاف',
    },
    it: {
      name: 'Matrimonio',
      metaTitle: 'Bracciali LED per Matrimoni | Party LED — Pista da ballo indimenticabile',
      metaDescription: 'Bracciali LED sincronizzati per matrimoni: primo ballo illuminato, foto magiche, personalizzazione gratuita. Kit da 50 a 1000 invitati.',
      h1: 'Bracciali LED per Matrimoni',
      subtitle: 'Trasforma il primo ballo in un momento indimenticabile',
      intro: 'Il momento in cui tutta la sala si illumina insieme è quello di cui i vostri invitati parleranno per anni. I nostri bracciali si sincronizzano con la musica del DJ e trasformano la pista in uno spettacolo. Ogni kit include la stampa dei vostri nomi in un colore, gratis.',
      benefits: [
        'Primo ballo spettacolare: tutti i bracciali si accendono nello stesso istante.',
        'Foto e video incomparabili: la luce portata dagli invitati illumina ogni scatto.',
        'I vostri nomi e la data stampati su ogni bracciale — un ricordo da portare a casa.',
        'Un link NFC al vostro album fotografico, playlist o guest book digitale.',
      ],
      faq: [
        { q: 'Quanti bracciali servono?', a: 'Un bracciale per ogni invitato in pista. I kit coprono da 50 a 1000 persone con prezzi a scalare.' },
        { q: 'Il mio DJ può gestire i bracciali?', a: 'Sì. Ogni kit include un controller a scelta: mini, da app mobile o console professionale per computer.' },
        { q: 'Si possono personalizzare?', a: 'La stampa in un colore (nomi, data, iniziali) è inclusa gratuitamente, insieme al link NFC.' },
      ],
      cta: 'Vedi i kit matrimonio',
    },
  },

  festival: {
    image: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    fr: {
      name: 'Festival',
      metaTitle: 'Bracelets LED pour Festival et Concert | Party LED — Effet stadium',
      metaDescription: 'Bracelets LED synchronisés pour festivals et concerts : effet stadium, contrôle DMX, jusqu\'à 1000 participants. Marquage sponsor offert.',
      h1: 'Bracelets LED pour Festival & Concert',
      subtitle: 'L\'effet stadium, du premier rang au fond du site',
      intro: 'Un festival se vit debout, ensemble. Nos bracelets LED synchronisés créent des vagues de lumière sur toute la foule, calées sur le rythme de la scène. Le public devient une partie du show — et vos sponsors gagnent une visibilité que personne n\'oublie.',
      benefits: [
        'Vagues et effets de couleur pilotés en direct depuis la régie.',
        'Portée longue distance : la foule entière réagit, même à 100 mètres de la scène.',
        'Visibilité sponsor : logo en 1 couleur offert sur chaque bracelet.',
        'Contenu viral garanti : les vidéos de la foule illuminée circulent seules sur les réseaux.',
      ],
      faq: [
        { q: 'Jusqu\'à combien de participants ?', a: 'Nos kits couvrent de 50 à 1000 personnes, et plusieurs kits peuvent être combinés pour des jauges supérieures.' },
        { q: 'Qui pilote la lumière ?', a: 'Votre régisseur, avec le contrôleur professionnel pour ordinateur inclus. Nous proposons aussi un technicien éclairage en option.' },
        { q: 'Les bracelets sont-ils réutilisables ?', a: 'Oui. Les piles CR2032 sont remplaçables : après collecte, les bracelets repartent pour un nouvel événement.' },
      ],
      cta: 'Voir les kits festival',
    },
    en: {
      name: 'Festival',
      metaTitle: 'LED Wristbands for Festivals & Concerts | Party LED — Stadium effect',
      metaDescription: 'Synchronised LED wristbands for festivals and concerts: stadium effect, live control, up to 1000 attendees. Free sponsor branding.',
      h1: 'LED Wristbands for Festivals & Concerts',
      subtitle: 'The stadium effect, from front row to the back of the field',
      intro: 'A festival is lived standing, together. Our synchronised LED wristbands create waves of light across the whole crowd, locked to the beat of the stage. The audience becomes part of the show — and your sponsors gain visibility nobody forgets.',
      benefits: [
        'Waves and colour effects driven live from the control booth.',
        'Long range: the entire crowd reacts, even 100 metres from the stage.',
        'Sponsor visibility: one-colour logo included free on every wristband.',
        'Guaranteed viral content: videos of a glowing crowd spread on their own.',
      ],
      faq: [
        { q: 'How many attendees can it cover?', a: 'Kits cover 50 to 1000 people, and several kits can be combined for larger capacities.' },
        { q: 'Who controls the lights?', a: 'Your stage manager, using the included professional desktop controller. A lighting technician is available as an option.' },
        { q: 'Are wristbands reusable?', a: 'Yes. The CR2032 cells are replaceable: once collected, the wristbands are ready for another event.' },
      ],
      cta: 'See festival kits',
    },
    ar: {
      name: 'مهرجان',
      metaTitle: 'أسورة LED للمهرجانات والحفلات | Party LED',
      metaDescription: 'أسورة LED متزامنة للمهرجانات والحفلات: تأثير الملعب، تحكم مباشر، حتى 1000 مشارك. طباعة شعار الراعي مجانًا.',
      h1: 'أسورة LED للمهرجانات والحفلات',
      subtitle: 'تأثير الملعب، من الصف الأول إلى آخر الموقع',
      intro: 'المهرجان يُعاش واقفًا ومعًا. تخلق أسورتنا المتزامنة أمواجًا من الضوء عبر الجمهور بالكامل، متناسقة مع إيقاع المسرح. يصبح الجمهور جزءًا من العرض — ويحصل رعاتك على ظهور لا يُنسى.',
      benefits: [
        'أمواج وتأثيرات لونية يتم التحكم بها مباشرة من غرفة التحكم.',
        'مدى طويل: يتفاعل الجمهور بالكامل، حتى على مسافة 100 متر من المسرح.',
        'ظهور الراعي: شعار بلون واحد مجانًا على كل سوار.',
        'محتوى فيروسي مضمون: فيديوهات الجمهور المضاء تنتشر من تلقاء نفسها.',
      ],
      faq: [
        { q: 'كم عدد المشاركين الذي يمكن تغطيته؟', a: 'تغطي الأطقم من 50 إلى 1000 شخص، ويمكن دمج عدة أطقم لسعات أكبر.' },
        { q: 'من يتحكم بالإضاءة؟', a: 'مدير المسرح، عبر وحدة التحكم الاحترافية المرفقة. يتوفر أيضًا فني إضاءة كخيار إضافي.' },
        { q: 'هل الأسورة قابلة لإعادة الاستخدام؟', a: 'نعم. بطاريات CR2032 قابلة للاستبدال: بعد جمع الأسورة تصبح جاهزة لفعالية أخرى.' },
      ],
      cta: 'اطلع على أطقم المهرجانات',
    },
    it: {
      name: 'Festival',
      metaTitle: 'Bracciali LED per Festival e Concerti | Party LED — Effetto stadio',
      metaDescription: 'Bracciali LED sincronizzati per festival e concerti: effetto stadio, controllo dal vivo, fino a 1000 partecipanti. Logo sponsor gratuito.',
      h1: 'Bracciali LED per Festival e Concerti',
      subtitle: 'L\'effetto stadio, dalla prima fila al fondo dell\'area',
      intro: 'Un festival si vive in piedi, insieme. I nostri bracciali LED sincronizzati creano onde di luce su tutta la folla, a tempo con il palco. Il pubblico diventa parte dello spettacolo — e i tuoi sponsor guadagnano una visibilità indimenticabile.',
      benefits: [
        'Onde ed effetti di colore gestiti dal vivo dalla regia.',
        'Lunga portata: tutta la folla reagisce, anche a 100 metri dal palco.',
        'Visibilità sponsor: logo in un colore incluso gratuitamente su ogni bracciale.',
        'Contenuti virali garantiti: i video della folla illuminata circolano da soli.',
      ],
      faq: [
        { q: 'Quanti partecipanti si possono coprire?', a: 'I kit coprono da 50 a 1000 persone e più kit possono essere combinati per capienze maggiori.' },
        { q: 'Chi controlla le luci?', a: 'Il tuo tecnico, con la console professionale inclusa. È disponibile anche un tecnico luci come opzione.' },
        { q: 'I bracciali sono riutilizzabili?', a: 'Sì. Le batterie CR2032 sono sostituibili: dopo la raccolta i bracciali sono pronti per un altro evento.' },
      ],
      cta: 'Vedi i kit festival',
    },
  },

  entreprise: {
    image: 'https://images.unsplash.com/photo-1700514077430-3659e38eb5e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    fr: {
      name: 'Entreprise',
      metaTitle: 'Bracelets LED Événement d\'Entreprise | Party LED — Soirée de gala, convention',
      metaDescription: 'Bracelets LED personnalisés à vos couleurs de marque pour soirées d\'entreprise, conventions et lancements produit. Logo et lien NFC offerts.',
      h1: 'Bracelets LED pour Événement d\'Entreprise',
      subtitle: 'Votre marque, portée par chaque participant',
      intro: 'Soirée de gala, convention, lancement produit ou team building : les bracelets LED alignent toute la salle sur vos couleurs de marque. Chaque participant devient un point lumineux de votre identité — et repart avec un objet marqué à votre logo.',
      benefits: [
        'Bracelets réglés sur les couleurs exactes de votre charte graphique.',
        'Votre logo en 1 couleur offert sur chaque bracelet.',
        'Lien NFC offert vers votre site, votre application ou un formulaire de contact.',
        'Temps fort scénarisé : révélation produit, remise de prix, photo de groupe illuminée.',
      ],
      faq: [
        { q: 'Peut-on obtenir un devis sur mesure ?', a: 'Oui, notre formulaire de devis prend en compte le nombre de participants, la personnalisation et la logistique.' },
        { q: 'Livrez-vous en Europe et aux Émirats ?', a: 'Oui : Nouvelle Vision (Marseille, France) pour l\'Europe et World Promotional Products (Dubai, UAE) pour les Émirats.' },
        { q: 'Facturation entreprise ?', a: 'Nous émettons une facture professionnelle avec TVA pour chaque commande.' },
      ],
      cta: 'Demander un devis entreprise',
    },
    en: {
      name: 'Corporate',
      metaTitle: 'LED Wristbands for Corporate Events | Party LED — Gala, convention',
      metaDescription: 'Custom LED wristbands in your brand colours for corporate parties, conventions and product launches. Free logo and NFC link.',
      h1: 'LED Wristbands for Corporate Events',
      subtitle: 'Your brand, worn by every attendee',
      intro: 'Gala dinner, convention, product launch or team building: LED wristbands align the whole room with your brand colours. Every attendee becomes a glowing point of your identity — and leaves with an item carrying your logo.',
      benefits: [
        'Wristbands tuned to the exact colours of your brand guidelines.',
        'Your one-colour logo included free on every wristband.',
        'Free NFC link to your website, app or contact form.',
        'A scripted highlight: product reveal, awards, glowing group photo.',
      ],
      faq: [
        { q: 'Can we get a custom quote?', a: 'Yes, our quote form covers attendee count, personalisation and logistics.' },
        { q: 'Do you deliver in Europe and the UAE?', a: 'Yes: Nouvelle Vision (Marseille, France) for Europe and World Promotional Products (Dubai, UAE) for the Emirates.' },
        { q: 'Business invoicing?', a: 'We issue a professional VAT invoice for every order.' },
      ],
      cta: 'Request a corporate quote',
    },
    ar: {
      name: 'شركات',
      metaTitle: 'أسورة LED لفعاليات الشركات | Party LED',
      metaDescription: 'أسورة LED مخصصة بألوان علامتك التجارية لحفلات الشركات والمؤتمرات وإطلاق المنتجات. الشعار ورابط NFC مجانًا.',
      h1: 'أسورة LED لفعاليات الشركات',
      subtitle: 'علامتك التجارية، يحملها كل مشارك',
      intro: 'حفل عشاء، مؤتمر، إطلاق منتج أو بناء فريق: تُوحّد أسورة LED القاعة بأكملها بألوان علامتك. يصبح كل مشارك نقطة مضيئة من هويتك — ويعود بقطعة تحمل شعارك.',
      benefits: [
        'أسورة مضبوطة على ألوان دليل هويتك بدقة.',
        'شعارك بلون واحد مجانًا على كل سوار.',
        'رابط NFC مجاني إلى موقعك أو تطبيقك أو نموذج التواصل.',
        'لحظة مميزة مُخططة: الكشف عن المنتج، توزيع الجوائز، صورة جماعية مضاءة.',
      ],
      faq: [
        { q: 'هل يمكن الحصول على عرض سعر مخصص؟', a: 'نعم، يشمل نموذج عرض السعر عدد المشاركين والتخصيص والخدمات اللوجستية.' },
        { q: 'هل تقومون بالتوصيل إلى أوروبا والإمارات؟', a: 'نعم: Nouvelle Vision (مرسيليا، فرنسا) لأوروبا وWorld Promotional Products (دبي، الإمارات) للإمارات.' },
        { q: 'فواتير للشركات؟', a: 'نصدر فاتورة احترافية مع ضريبة القيمة المضافة لكل طلب.' },
      ],
      cta: 'اطلب عرض سعر للشركات',
    },
    it: {
      name: 'Aziendale',
      metaTitle: 'Bracciali LED per Eventi Aziendali | Party LED — Gala, convention',
      metaDescription: 'Bracciali LED personalizzati con i colori del tuo brand per feste aziendali, convention e lanci di prodotto. Logo e link NFC gratuiti.',
      h1: 'Bracciali LED per Eventi Aziendali',
      subtitle: 'Il tuo brand, indossato da ogni partecipante',
      intro: 'Cena di gala, convention, lancio di prodotto o team building: i bracciali LED allineano tutta la sala ai colori del tuo brand. Ogni partecipante diventa un punto luminoso della tua identità — e torna a casa con un oggetto col tuo logo.',
      benefits: [
        'Bracciali regolati sui colori esatti della tua brand identity.',
        'Il tuo logo in un colore incluso gratuitamente su ogni bracciale.',
        'Link NFC gratuito al tuo sito, alla tua app o a un form di contatto.',
        'Un momento clou scenografico: reveal del prodotto, premiazione, foto di gruppo illuminata.',
      ],
      faq: [
        { q: 'Possiamo avere un preventivo su misura?', a: 'Sì, il nostro form considera numero di partecipanti, personalizzazione e logistica.' },
        { q: 'Consegnate in Europa e negli Emirati?', a: 'Sì: Nouvelle Vision (Marsiglia, Francia) per l\'Europa e World Promotional Products (Dubai, UAE) per gli Emirati.' },
        { q: 'Fatturazione aziendale?', a: 'Emettiamo una fattura professionale con IVA per ogni ordine.' },
      ],
      cta: 'Richiedi un preventivo aziendale',
    },
  },

  club: {
    image: 'https://images.unsplash.com/photo-1730818203797-897b2838105a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    fr: {
      name: 'Club',
      metaTitle: 'Bracelets LED pour Club et Discothèque | Party LED — Soirées signature',
      metaDescription: 'Bracelets LED synchronisés pour clubs et discothèques : soirées signature, contrôle par le DJ, bracelets réutilisables à piles remplaçables.',
      h1: 'Bracelets LED pour Club & Discothèque',
      subtitle: 'Une soirée signature que vos concurrents ne peuvent pas copier',
      intro: 'Un club se distingue par ce qu\'on y ressent. Les bracelets LED synchronisés donnent à votre dancefloor une signature visuelle immédiate : la salle respire au rythme du DJ, et chaque story publiée devient une publicité pour votre établissement.',
      benefits: [
        'Pilotage direct par votre DJ, depuis son smartphone ou son ordinateur.',
        'Bracelets réutilisables, piles remplaçables : un seul investissement pour des dizaines de soirées.',
        'Votre nom de club marqué en 1 couleur, offert.',
        'Stories et Reels en cascade : la lumière portée fait exploser votre visibilité sociale.',
      ],
      faq: [
        { q: 'Combien de soirées avec un kit ?', a: 'Les bracelets sont réutilisables : il suffit de remplacer les piles CR2032 entre deux soirées.' },
        { q: 'Le DJ doit-il être formé ?', a: 'Non. Le contrôleur par application mobile s\'utilise en quelques minutes. Un technicien éclairage est disponible en option.' },
        { q: 'Peut-on récupérer les bracelets à la sortie ?', a: 'Oui, c\'est le modèle le plus rentable : distribution à l\'entrée, collecte à la sortie, recharge, réutilisation.' },
      ],
      cta: 'Voir les kits club',
    },
    en: {
      name: 'Club',
      metaTitle: 'LED Wristbands for Clubs & Nightclubs | Party LED — Signature nights',
      metaDescription: 'Synchronised LED wristbands for clubs and nightclubs: signature nights, DJ control, reusable wristbands with replaceable cells.',
      h1: 'LED Wristbands for Clubs & Nightclubs',
      subtitle: 'A signature night your competitors cannot copy',
      intro: 'A club stands out by how it feels. Synchronised LED wristbands give your dancefloor an instant visual signature: the room breathes with the DJ, and every story posted becomes an ad for your venue.',
      benefits: [
        'Controlled directly by your DJ, from a phone or a laptop.',
        'Reusable wristbands with replaceable cells: one investment for dozens of nights.',
        'Your club name printed in one colour, free.',
        'Stories and Reels on repeat: worn light multiplies your social reach.',
      ],
      faq: [
        { q: 'How many nights per kit?', a: 'Wristbands are reusable: simply swap the CR2032 cells between nights.' },
        { q: 'Does the DJ need training?', a: 'No. The mobile app controller takes minutes to learn. A lighting technician is available as an option.' },
        { q: 'Can we collect wristbands on the way out?', a: 'Yes, that is the most profitable model: hand out at the door, collect at exit, recharge, reuse.' },
      ],
      cta: 'See club kits',
    },
    ar: {
      name: 'نادي',
      metaTitle: 'أسورة LED للنوادي والملاهي الليلية | Party LED',
      metaDescription: 'أسورة LED متزامنة للنوادي والملاهي: ليالٍ مميزة، تحكم من منسق الأغاني، أسورة قابلة لإعادة الاستخدام ببطاريات قابلة للاستبدال.',
      h1: 'أسورة LED للنوادي والملاهي الليلية',
      subtitle: 'ليلة مميزة لا يمكن لمنافسيك تقليدها',
      intro: 'يتميز النادي بما يُشعر به الناس. تمنح أسورة LED المتزامنة حلبتك هوية بصرية فورية: تتنفس القاعة مع منسق الأغاني، وكل قصة تُنشر تصبح إعلانًا لمكانك.',
      benefits: [
        'تحكم مباشر من منسق الأغاني، عبر الهاتف أو الكمبيوتر.',
        'أسورة قابلة لإعادة الاستخدام ببطاريات قابلة للاستبدال: استثمار واحد لعشرات الليالي.',
        'اسم ناديك مطبوع بلون واحد مجانًا.',
        'قصص وريلز متواصلة: الضوء المحمول يضاعف انتشارك على الشبكات.',
      ],
      faq: [
        { q: 'كم ليلة يمكن استخدام الطقم؟', a: 'الأسورة قابلة لإعادة الاستخدام: يكفي استبدال بطاريات CR2032 بين ليلة وأخرى.' },
        { q: 'هل يحتاج منسق الأغاني إلى تدريب؟', a: 'لا. وحدة التحكم عبر التطبيق تُتعلم في دقائق. يتوفر فني إضاءة كخيار إضافي.' },
        { q: 'هل يمكن استعادة الأسورة عند الخروج؟', a: 'نعم، وهو النموذج الأكثر ربحية: التوزيع عند الدخول، الجمع عند الخروج، الشحن، إعادة الاستخدام.' },
      ],
      cta: 'اطلع على أطقم النوادي',
    },
    it: {
      name: 'Club',
      metaTitle: 'Bracciali LED per Club e Discoteche | Party LED — Serate signature',
      metaDescription: 'Bracciali LED sincronizzati per club e discoteche: serate signature, controllo del DJ, bracciali riutilizzabili con batterie sostituibili.',
      h1: 'Bracciali LED per Club e Discoteche',
      subtitle: 'Una serata signature che i concorrenti non possono copiare',
      intro: 'Un club si distingue per ciò che si sente. I bracciali LED sincronizzati danno alla tua pista una firma visiva immediata: la sala respira col DJ e ogni story pubblicata diventa pubblicità per il tuo locale.',
      benefits: [
        'Controllo diretto del tuo DJ, da smartphone o computer.',
        'Bracciali riutilizzabili con batterie sostituibili: un investimento per decine di serate.',
        'Il nome del tuo club stampato in un colore, gratis.',
        'Stories e Reels a raffica: la luce indossata moltiplica la tua visibilità social.',
      ],
      faq: [
        { q: 'Quante serate con un kit?', a: 'I bracciali sono riutilizzabili: basta sostituire le batterie CR2032 tra una serata e l\'altra.' },
        { q: 'Il DJ deve essere formato?', a: 'No. Il controller da app mobile si impara in pochi minuti. Un tecnico luci è disponibile come opzione.' },
        { q: 'Si possono recuperare all\'uscita?', a: 'Sì, è il modello più redditizio: distribuzione all\'ingresso, raccolta all\'uscita, ricarica, riutilizzo.' },
      ],
      cta: 'Vedi i kit club',
    },
  },

  concert: {
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/gallery-real-09.jpg`,
    fr: {
      name: 'Concert',
      metaTitle: 'Bracelets LED pour Concert | Party LED — Toute la salle dans la lumière',
      metaDescription: 'Bracelets LED synchronisés pour concerts et tournées : public illuminé sur chaque refrain, effets pilotés depuis la régie, marquage artiste offert. Kits de 50 à 1000 spectateurs.',
      h1: 'Bracelets LED pour Concert',
      subtitle: 'Le public devient le plus beau décor de la scène',
      intro: 'Sur un concert, la lumière ne doit pas s\'arrêter au bord de la scène. Nos bracelets LED synchronisés étendent le show jusqu\'au dernier rang : la salle change de couleur sur chaque refrain, s\'éteint pendant les ballades et repart d\'un seul coup au moment fort. Le marquage du nom de l\'artiste ou de la tournée est offert.',
      benefits: [
        'Chaque titre a sa couleur : la salle suit la setlist, du premier morceau au rappel.',
        'Piloté depuis la régie, en même temps que le son et les lumières de scène.',
        'Des images de foule spectaculaires pour l\'aftermovie et les réseaux de l\'artiste.',
        'Nom de l\'artiste ou de la tournée marqué sur chaque bracelet — le public le garde.',
      ],
      faq: [
        { q: 'Combien de bracelets pour ma salle ?', a: 'Comptez un bracelet par spectateur. Nos kits couvrent de 50 à 1000 personnes, et plusieurs kits se combinent pour les salles plus grandes.' },
        { q: 'Qui déclenche les effets pendant le concert ?', a: 'Votre régisseur lumière. Le contrôleur professionnel se pilote depuis un ordinateur, le contrôleur mobile depuis un smartphone en coulisses.' },
        { q: 'Les bracelets gênent-ils la captation vidéo ?', a: 'Au contraire : ils remplissent le champ de lumière colorée. Les effets peuvent être coupés instantanément pendant les moments acoustiques.' },
      ],
      cta: 'Voir les kits concert',
    },
    en: {
      name: 'Concert',
      metaTitle: 'LED Wristbands for Concerts | Party LED — The whole room in light',
      metaDescription: 'Synchronised LED wristbands for concerts and tours: the crowd lights up on every chorus, effects driven from front of house, free artist branding. Kits from 50 to 1000 people.',
      h1: 'LED Wristbands for Concerts',
      subtitle: 'The crowd becomes the best set design on stage',
      intro: 'At a concert, light should not stop at the edge of the stage. Our synchronised LED wristbands extend the show to the very last row: the room changes colour on every chorus, goes dark during the ballads and comes back all at once on the drop. Artist or tour branding is included free.',
      benefits: [
        'Every song gets its colour: the room follows the setlist, from opener to encore.',
        'Driven from front of house, together with sound and stage lighting.',
        'Spectacular crowd footage for the aftermovie and the artist\'s socials.',
        'Artist or tour name printed on every wristband — the audience keeps it.',
      ],
      faq: [
        { q: 'How many wristbands for my venue?', a: 'One wristband per attendee. Kits cover 50 to 1000 people and several kits combine for larger venues.' },
        { q: 'Who triggers the effects during the show?', a: 'Your lighting operator. The professional controller runs from a computer, the mobile controller from a smartphone backstage.' },
        { q: 'Do wristbands disturb the video capture?', a: 'Quite the opposite: they fill the frame with colour. Effects can be cut instantly during acoustic moments.' },
      ],
      cta: 'See concert kits',
    },
    ar: {
      name: 'حفل موسيقي',
      metaTitle: 'أسورة LED للحفلات الموسيقية | Party LED',
      metaDescription: 'أسورة LED متزامنة للحفلات الموسيقية والجولات: جمهور مضاء في كل لازمة، تحكم من غرفة الإضاءة، طباعة اسم الفنان مجانًا. أطقم من 50 إلى 1000 شخص.',
      h1: 'أسورة LED للحفلات الموسيقية',
      subtitle: 'الجمهور يصبح أجمل ديكور للمسرح',
      intro: 'في الحفل الموسيقي، لا ينبغي أن يتوقف الضوء عند حدود المسرح. تمتد أسورتنا المتزامنة إلى الصف الأخير: تتغير ألوان القاعة مع كل لازمة، وتنطفئ في المقاطع الهادئة، وتعود كلها في اللحظة القوية. طباعة اسم الفنان أو الجولة مجانية.',
      benefits: [
        'لكل أغنية لونها: القاعة تتبع قائمة الأغاني من البداية حتى الإعادة.',
        'التحكم من غرفة الإضاءة، بالتزامن مع الصوت وإضاءة المسرح.',
        'مشاهد جمهور مذهلة لفيديو ما بعد الحفل وحسابات الفنان.',
        'اسم الفنان أو الجولة مطبوع على كل سوار — يحتفظ به الجمهور.',
      ],
      faq: [
        { q: 'كم سوارًا تحتاج قاعتي؟', a: 'سوار واحد لكل حاضر. تغطي أطقمنا من 50 إلى 1000 شخص، ويمكن الجمع بين عدة أطقم للقاعات الأكبر.' },
        { q: 'من يشغّل التأثيرات أثناء الحفل؟', a: 'مسؤول الإضاءة لديك. تعمل الوحدة الاحترافية من الكمبيوتر، ووحدة الهاتف من الكواليس.' },
        { q: 'هل تُزعج الأسورة تصوير الفيديو؟', a: 'على العكس، تملأ الكادر بالألوان. ويمكن إيقاف التأثيرات فورًا في المقاطع الصوتية الهادئة.' },
      ],
      cta: 'اطلع على أطقم الحفلات',
    },
    it: {
      name: 'Concerto',
      metaTitle: 'Bracciali LED per Concerti | Party LED — Tutta la sala nella luce',
      metaDescription: 'Bracciali LED sincronizzati per concerti e tour: il pubblico si illumina a ogni refrain, effetti gestiti dalla regia, stampa artista gratuita. Kit da 50 a 1000 persone.',
      h1: 'Bracciali LED per Concerti',
      subtitle: 'Il pubblico diventa la scenografia più bella',
      intro: 'In un concerto la luce non deve fermarsi al bordo del palco. I nostri bracciali sincronizzati portano lo show fino all\'ultima fila: la sala cambia colore a ogni refrain, si spegne nelle ballate e riparte tutta insieme sul momento forte. La stampa del nome dell\'artista o del tour è inclusa.',
      benefits: [
        'Ogni brano ha il suo colore: la sala segue la setlist, dall\'apertura al bis.',
        'Gestito dalla regia, insieme ad audio e luci di palco.',
        'Immagini di pubblico spettacolari per l\'aftermovie e i social dell\'artista.',
        'Nome dell\'artista o del tour stampato su ogni bracciale — il pubblico lo conserva.',
      ],
      faq: [
        { q: 'Quanti bracciali per la mia sala?', a: 'Un bracciale per spettatore. I kit coprono da 50 a 1000 persone e si combinano per sale più grandi.' },
        { q: 'Chi lancia gli effetti durante il concerto?', a: 'Il tuo tecnico luci. Il controller professionale si gestisce da computer, quello mobile da smartphone dietro le quinte.' },
        { q: 'I bracciali disturbano le riprese?', a: 'Al contrario: riempiono l\'inquadratura di colore. Gli effetti si possono spegnere subito nei momenti acustici.' },
      ],
      cta: 'Vedi i kit concerto',
    },
  },

  sport: {
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/hero-crowd.jpg`,
    fr: {
      name: 'Club de sport',
      metaTitle: 'Bracelets LED pour Club de Sport & Stade | Party LED — Tribunes aux couleurs du club',
      metaDescription: 'Bracelets LED synchronisés pour clubs de sport, stades et salles : tribunes aux couleurs du club, entrée des joueurs illuminée, logo sponsor offert. Kits de 50 à 1000 supporters.',
      h1: 'Bracelets LED pour Clubs de Sport',
      subtitle: 'Des tribunes entières aux couleurs de votre club',
      intro: 'Un stade se gagne aussi dans les tribunes. Nos bracelets LED synchronisés habillent vos supporters aux couleurs du club : mur de lumière à l\'entrée des joueurs, éclair à chaque but, tribune entière allumée pour la minute d\'applaudissements. Le logo du club ou du sponsor est marqué sur chaque bracelet, offert.',
      benefits: [
        'Entrée des joueurs spectaculaire : tribunes allumées aux couleurs du club, en une seconde.',
        'Un effet lumineux déclenché à chaque but, chaque panier, chaque point décisif.',
        'Logo du sponsor maillot sur chaque bracelet : une visibilité qui repart à la maison.',
        'Bracelets réutilisables d\'un match à l\'autre — un investissement pour toute la saison.',
      ],
      faq: [
        { q: 'Combien de bracelets pour mes tribunes ?', a: 'Comptez un bracelet par supporter présent. Nos kits vont de 50 à 1000 personnes et se combinent pour équiper un virage entier.' },
        { q: 'Qui déclenche les effets pendant le match ?', a: 'Votre speaker ou votre régie. Le contrôleur mobile suffit pour lancer un effet depuis le bord du terrain.' },
        { q: 'Peut-on les réutiliser à chaque match ?', a: 'Oui. Les bracelets sont réutilisables : distribution à l\'entrée, récupération à la sortie, remplacement des piles CR2032 entre deux rencontres.' },
      ],
      cta: 'Voir les kits pour clubs de sport',
    },
    en: {
      name: 'Sports club',
      metaTitle: 'LED Wristbands for Sports Clubs & Stadiums | Party LED — Stands in club colours',
      metaDescription: 'Synchronised LED wristbands for sports clubs, stadiums and arenas: stands in club colours, lit player entrance, free sponsor logo. Kits from 50 to 1000 supporters.',
      h1: 'LED Wristbands for Sports Clubs',
      subtitle: 'Whole stands in your club\'s colours',
      intro: 'A stadium is also won in the stands. Our synchronised LED wristbands dress your supporters in the club colours: a wall of light for the player entrance, a flash on every goal, the whole stand lit for the minute of applause. The club or sponsor logo is printed on every wristband, free.',
      benefits: [
        'Spectacular player entrance: stands lit in club colours in a single second.',
        'A light effect fired on every goal, every basket, every decisive point.',
        'Shirt sponsor logo on every wristband: visibility that goes home with the fans.',
        'Reusable from one game to the next — an investment for the whole season.',
      ],
      faq: [
        { q: 'How many wristbands for my stands?', a: 'One wristband per supporter. Kits cover 50 to 1000 people and combine to equip an entire end.' },
        { q: 'Who fires the effects during the game?', a: 'Your announcer or control room. The mobile controller is enough to launch an effect from pitch side.' },
        { q: 'Can they be reused every match?', a: 'Yes. Wristbands are reusable: hand out at the gate, collect on the way out, swap the CR2032 cells between games.' },
      ],
      cta: 'See kits for sports clubs',
    },
    ar: {
      name: 'نادٍ رياضي',
      metaTitle: 'أسورة LED للأندية الرياضية والملاعب | Party LED',
      metaDescription: 'أسورة LED متزامنة للأندية الرياضية والملاعب: مدرجات بألوان النادي، دخول اللاعبين مضاء، شعار الراعي مجانًا. أطقم من 50 إلى 1000 مشجع.',
      h1: 'أسورة LED للأندية الرياضية',
      subtitle: 'مدرجات كاملة بألوان ناديك',
      intro: 'الملعب يُكسب في المدرجات أيضًا. تُلبس أسورتنا المتزامنة مشجعيك ألوان النادي: جدار من الضوء عند دخول اللاعبين، وميض مع كل هدف، ومدرج كامل مضاء في دقيقة التصفيق. شعار النادي أو الراعي مطبوع على كل سوار مجانًا.',
      benefits: [
        'دخول مذهل للاعبين: مدرجات مضاءة بألوان النادي في ثانية واحدة.',
        'تأثير ضوئي مع كل هدف أو سلة أو نقطة حاسمة.',
        'شعار راعي القميص على كل سوار: ظهور يعود مع المشجع إلى بيته.',
        'أسورة قابلة لإعادة الاستخدام من مباراة إلى أخرى — استثمار للموسم بأكمله.',
      ],
      faq: [
        { q: 'كم سوارًا لمدرجاتي؟', a: 'سوار لكل مشجع حاضر. تغطي أطقمنا من 50 إلى 1000 شخص ويمكن الجمع بينها لتجهيز مدرج كامل.' },
        { q: 'من يشغّل التأثيرات أثناء المباراة؟', a: 'المعلّق أو غرفة التحكم. وحدة التحكم عبر الهاتف تكفي لإطلاق تأثير من حافة الملعب.' },
        { q: 'هل يمكن إعادة استخدامها كل مباراة؟', a: 'نعم. التوزيع عند الدخول، والاسترجاع عند الخروج، وتغيير بطاريات CR2032 بين المباريات.' },
      ],
      cta: 'اطلع على أطقم الأندية الرياضية',
    },
    it: {
      name: 'Club sportivo',
      metaTitle: 'Bracciali LED per Club Sportivi e Stadi | Party LED — Tribune nei colori del club',
      metaDescription: 'Bracciali LED sincronizzati per club sportivi, stadi e palazzetti: tribune nei colori del club, ingresso squadre illuminato, logo sponsor gratuito. Kit da 50 a 1000 tifosi.',
      h1: 'Bracciali LED per Club Sportivi',
      subtitle: 'Tribune intere nei colori del tuo club',
      intro: 'Uno stadio si vince anche in tribuna. I nostri bracciali sincronizzati vestono i tifosi con i colori del club: muro di luce all\'ingresso delle squadre, lampo a ogni gol, tribuna intera accesa per il minuto di applausi. Il logo del club o dello sponsor è stampato su ogni bracciale, gratis.',
      benefits: [
        'Ingresso squadre spettacolare: tribune accese nei colori del club in un secondo.',
        'Un effetto luminoso a ogni gol, canestro o punto decisivo.',
        'Logo dello sponsor di maglia su ogni bracciale: visibilità che torna a casa col tifoso.',
        'Riutilizzabili da una partita all\'altra — un investimento per tutta la stagione.',
      ],
      faq: [
        { q: 'Quanti bracciali per le mie tribune?', a: 'Un bracciale per tifoso. I kit coprono da 50 a 1000 persone e si combinano per attrezzare una curva intera.' },
        { q: 'Chi lancia gli effetti durante la partita?', a: 'Lo speaker o la regia. Il controller mobile basta per lanciare un effetto dal bordo campo.' },
        { q: 'Si riutilizzano a ogni partita?', a: 'Sì: distribuzione all\'ingresso, raccolta all\'uscita, sostituzione delle batterie CR2032 tra le partite.' },
      ],
      cta: 'Vedi i kit per club sportivi',
    },
  },
};
